import { render, staticRenderFns } from "./DashboardPagesList.vue?vue&type=template&id=d7f1f724&scoped=true&"
import script from "./DashboardPagesList.vue?vue&type=script&lang=js&"
export * from "./DashboardPagesList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPagesList.vue?vue&type=style&index=0&id=d7f1f724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f1f724",
  null
  
)

export default component.exports